<template>
  <div v-if="value && value._id && value.label">
    <div
      class="row align-center justify-center tournament-white--text italic px-2 caption"
      :class="color"
      style="border-radius: 2px; height: 20px"
    >
      {{ $t(`enrollments.statuses.${value._id}`) }}
    </div>
  </div>
</template>

<script>
import _ from "lodash";

export default {
  name: "EnrollmentChip",
  props: {
    value: {
      type: Object,
    },
  },

  computed: {
    color() {
      return (
        {
          waiting: "tournament-red",
          reviewing: "tournament-yellow",
          confirmed: "tournament-green",
          finished: "tournament-grey",
          rejected: "tournament-black",
          pending_payment: "tournament-yellow",
        }[_.get(this.value, "_id")] || "tournament-grey"
      );
    },
  },

  created() {
    // Keep safe when parent pass a undefined as prop
    if (!this.value) {
      this.$emit("input", {});
    }
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Enrollments/Chip/index.vue